import React from 'react';
import PropTypes from 'prop-types';

import { Member } from 'components/common/Elements/Elements';

import { getFullName, getInitials } from 'utils/common';
import { links } from 'data/constants';

const { innerIcons } = links;

const Person = ({ member }) => {
  const { firstName, lastName, email, initialscolor, icon } = member;

  const createMember = () => {
    return {
      fullName: getFullName(firstName, lastName),
      description: email,
      initials: getInitials(firstName, lastName),
      initialsColor: initialscolor,
      icon: icon === '-' || icon === 'NA' ? null : `${innerIcons}${icon}`
    };
  };

  return <Member member={createMember()} />;
};

Person.propTypes = {
  member: PropTypes.shape({
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    email: PropTypes.string,
    initialscolor: PropTypes.string,
    icon: PropTypes.string
  })
};

export default Person;
